/**
 * PAYG Credits A/B test helper (TP-193).
 *
 * Mirrors PaygCreditsTest.php — any logic change must be kept in sync.
 *
 * Variant bucketing: user.id % 2
 *   0 → 'a' (control:   PAYG UI hidden, purchase blocked by API)
 *   1 → 'b' (treatment: PAYG UI fully visible)
 *
 * The test only applies to:
 *   - Signed-in users
 *   - On production: paygCreditsPricingPage toggle on + joined on/after TEST_START_DATE
 *   - On non-production: always active so staging can be verified
 */

import featureToggles from 'featureToggles';

const TEST_START_DATE = '2026-07-17';

/**
 * Returns the A/B variant for a user, or null if the user is not in the test.
 *
 * @param {object|null} user
 * @returns {'a'|'b'|null}
 */
export const getPaygCreditsVariant = (user) => {
  if (!user?.id) return null;

  if (__CLOUD_ENV__ === 'production') {
    if (!featureToggles.paygCreditsPricingPage) return null;

    const joined = user.joined ? new Date(user.joined) : null;
    if (!joined || joined < new Date(TEST_START_DATE)) return null;
  }

  return user.id % 2 === 0 ? 'a' : 'b';
};
